import { render, staticRenderFns } from "./informationDisclosure.vue?vue&type=template&id=22c9e5b6&scoped=true&"
import script from "./informationDisclosure.vue?vue&type=script&lang=js&"
export * from "./informationDisclosure.vue?vue&type=script&lang=js&"
import style0 from "./informationDisclosure.vue?vue&type=style&index=0&id=22c9e5b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9e5b6",
  null
  
)

export default component.exports